import styled from 'styled-components'

export const Wrapper = styled.div`
  .ant-divider-horizontal {
    margin: 10px 0;
  }
`

export const Container = styled.div``
